import React from "react";
import { Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { colors } from "./Theme/WebTheme";

// Mostra o status da verificação facial do usuário (Verificado / Pendente / Não verificado).
// Quando o logado é admin, o chip é clicável (Verificado ou Pendente) e leva à tela de
// verificação daquele usuário (a rota /facialvalidations é admin-only), permitindo rever
// a imagem usada e, no caso de aprovado, revogar/solicitar nova validação.
export default function FacialStatusChip({ user }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const isAdmin = auth && auth.profile && auth.profile.usertype === "admin";
  const status = user && user.facialStatus;

  if (status === "approved") {
    return (
      <Chip
        label={t("facial_verified")}
        size="small"
        clickable={isAdmin}
        onClick={
          isAdmin
            ? (e) => {
                e.stopPropagation();
                navigate(`/facialvalidations/${user.id}`);
              }
            : undefined
        }
        style={{
          backgroundColor: colors.GREEN,
          color: colors.WHITE,
          fontWeight: "bold",
          cursor: isAdmin ? "pointer" : "default",
        }}
      />
    );
  }

  if (status === "pending") {
    return (
      <Chip
        label={t("pending")}
        size="small"
        clickable={isAdmin}
        onClick={
          isAdmin
            ? (e) => {
                e.stopPropagation();
                navigate(`/facialvalidations/${user.id}`);
              }
            : undefined
        }
        style={{
          backgroundColor: "#f57c00",
          color: colors.WHITE,
          fontWeight: "bold",
          cursor: isAdmin ? "pointer" : "default",
        }}
      />
    );
  }

  return (
    <Chip
      label={t("facial_not_verified")}
      size="small"
      style={{ backgroundColor: colors.WALLET_CARD_SHADOW, color: colors.WHITE }}
    />
  );
}
